"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOwnerOfEntry = exports.createEntryId = exports.DISPLAY_NAME_MAX_LENGTH = void 0;
const zod_1 = require("zod");
exports.DISPLAY_NAME_MAX_LENGTH = 100;
/**
 * @link https://github.com/lessonup/lessonup/blob/a3ac598bc65668a5d456f348e2e8ac9ac3eec5b1/libs/lessonup-core/src/domain/entries/AssignmentEntry.ts
 */
const DbAssignmentEntrySchema = zod_1.z.object({
    _id: zod_1.z.string(),
    userId: zod_1.z.string(),
    assignmentId: zod_1.z.string(),
});
function createEntryId({ userId, assignmentId }) {
    return `${assignmentId}-${userId}`;
}
exports.createEntryId = createEntryId;
function isOwnerOfEntry(userId, entry) {
    return entry.userId === userId;
}
exports.isOwnerOfEntry = isOwnerOfEntry;
//# sourceMappingURL=db-assignment-entry.js.map